module.exports = __webpack_public_path__ + "172f5b5b8f9cd4100ca297b8982fd9ab.png";